// extracted by mini-css-extract-plugin
module.exports = {"menuShadow":"_2X3Z6","header":"_20lED","title":"_1HR0-","closeButton":"OX2bk","buttonMenuPanel":"_3MY4U","item":"_1hH4V","link":"opEn0"};